define('usuario-solicitacao-interesse-controller',[ 
      'usuario-solicitacao-interesse-resource',
      'imovel-resource',
      'crud-service'], function() {

  var app = angular.module('usuario.solicitacao.interesse.controller', 
    [
      'usuario.solicitacao.interesse.resource',
      'imovel.resource',
      'crud.service'
    ]
  );

  app.controller('UsuarioSolicitacaoInteresseControllerIndex', ['$scope', '$rootScope',  'UsuarioSolicitacaoInteresse',  'crud',
      function($scope, $rootScope,  UsuarioSolicitacaoInteresse,  crud) {
        crud.listSite($scope, UsuarioSolicitacaoInteresse);
        $scope.$watch('itens', function(result){
          $scope.itens = result;
        });

  }]);

  app.controller('UsuarioSolicitacaoInteresseControllerEdt', ['$scope', '$rootScope', 'UsuarioSolicitacaoInteresse', '$timeout', '$q',  'crud','Imovel',
    function($scope, $rootScope, UsuarioSolicitacaoInteresse, $timeout, $q,  crud, Imovel) {
      $scope.resetInteresse = function(){
        $scope.interesse = {
          usuint_codigo:null,
          ist_codigo:null,
          cid_codigo:null,
          usuint_obs:null,
          usuint_bairro:null
        }
        $scope.estado = {est_codigo: null};
      };
      $scope.resetInteresse();


      $scope.item = (item != null) ? item : null;
      if(item != null) {
          $scope.interesse = {
              usuint_codigo: item.usuint_codigo,
              ist_codigo: item.ist_codigo,
              cid_codigo: item.cid_codigo,
              usuint_obs: item.usuint_obs,
              usuint_bairro: item.usuint_bairro
          }
          if (item.cid_codigo != null) {
              $scope.cidade = item.Cidade;
              $scope.estado = item.Cidade.Estado;
          }
      }
        

      $scope.TipoImovel = TipoImovel;
      $scope.Estado  = Estado;


      $scope.changeCidade = function($select){
        if($scope.estado.est_codigo != null) {
          var cidade = '';
          if($select.search){
            cidade = $select.search.toUpperCase();
          }
          Imovel.getCidade($scope.estado.est_codigo, cidade).then(function (result) {
            $scope.cidades = result;
          });
        }

      };
      $scope.clearCidade = function(event){
       $scope.interesse.cid_codigo = null;
      }


      /*
       Auto complete Material
       */


      $scope.searchText = '';
      $scope.cidade = null;
      $scope.selectedItemChange = function (item) {
        $scope.interesse.cid_codigo = item.cid_codigo;
        $scope.cidade  = item;
      };


      var timeCidade;
      $scope.searchTextChange = function(text) {
        var deferred = $q.defer();
        $timeout.cancel(timeCidade);
        timeCidade = $timeout(function () {
          Imovel.getCidade($scope.estado.est_codigo, text).then(function (result) {
            deferred.resolve(result);
          })
        }, 1000, false);
        return deferred.promise;
      };
  //==============================


      $scope.inverteSelecao = function(key){
        _.map($scope.showFamily, function(reg, idx){
          $scope.showFamily[idx] = false;
        });
        $scope.showFamily[key] = true;
      }

      $scope.noValidIst = true;
      $scope.setSubTipo = function(ist_codigo){
        $scope.interesse.ist_codigo = ist_codigo;
        $scope.noValidIst = true;
      }

      $scope.save = function(){
        if ($scope.interesse.ist_codigo) {
          UsuarioSolicitacaoInteresse.save($scope.interesse).then(function(result){
              if(result.success){
               window.location = '/areacliente/solicitacao-interesse';
                  // $rootScope.$state.go('usuarioSolicitacaoInteresse', {msgSuccess:true});
              }
          });
        }else{
          $scope.noValidIst = false;
        }
      }
      $scope.showFamily = [];

      $scope.checkIstEscolhido = function(){
       $scope.obj.TipoImovel.map(function(vl, idx) {
         vl.ImovelSubtipo.map(function(vl2, idx2) {
          if(vl2.ist_codigo == $scope.interesse.ist_codigo) {
            $scope.showFamily[idx] = true;
           }
         });
       });
      }

  }]);
});

